export const GET_USERINFO = 'GET_USERINFO';
export const ADD_TAB = 'ADD_TAB';
export const DELETE_TAB = 'DELETE_TAB';
export const CLEAR_TABS = 'CLEAR_TABS';
export const CLEAR_ALL_TABS = 'CLEAR_ALL_TABS';
export const SET_TAB_NO_SAVE_TRUE = 'SET_TAB_NO_SAVE_TRUE';
export const SET_TAB_NO_SAVE_FALSE = 'SET_TAB_NO_SAVE_FALSE';
export const OPEN_MENU = 'OPEN_MENU';
export const SET_PERMISSIONS = 'SET_PERMISSIONS';
export const RESET_TABACTIVEID = 'RESET_TABACTIVEID';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js